/// <reference types="vite-plugin-svgr/client" />
import { Outlet } from 'react-router-dom';
import { Suspense } from 'react';

import ArtHelperLogo from '../assets/arthelperai-logo-horizontal.svg?react';
import HalfSplash from '../components/HalfSplash';
import { SupportButton } from '~/components/SupportButton';
import { useSpark } from '~/context/spark';

const AuthLayout: React.FC = () => {
  const { content, isLoading, hasSparkId } = useSpark();

  return (
    <div className="flex">
      <HalfSplash
        logo={<ArtHelperLogo />}
        description={
          <div
            className={`transition-opacity duration-300 ease-in-out ${
              hasSparkId && isLoading ? 'opacity-0' : 'opacity-100'
            }`}
          >
            <h1 className="text-4xl mt-10 font-bold text-white">{content.headerText}</h1>
          </div>
        }
        footer={<p className="text-white text-sm">© {new Date().getFullYear()} Art Storefronts</p>}
      />
      <div className="flex justify-center items-center flex-1 relative">
        <div className="absolute top-4 right-4 z-10">
          <SupportButton />
        </div>
        <div
          className={`transition-opacity duration-300 ease-in-out w-full ${
            hasSparkId && isLoading ? 'opacity-0' : 'opacity-100'
          }`}
        >
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
